import { useEffect, useState } from "react";
import Axios from "axios";
import { Link } from "react-router-dom";

export default function Stores() {
	const [selected, setSelected] = useState("All");
	const [stores, setStores] = useState([]);

	let api = process.env.REACT_APP_API_URL || "http://localhost:4000";

	useEffect(() => {
		Axios.post(api + "/retrieveStores", {
			tag: selected === "All" ? null : selected,
		}).then((res) => {
			let data = res.data;
			data.sort((a, b) => {
				return a.name.localeCompare(b.name);
			});
			setStores(data);
		});
	}, [selected, api]);

	function handleClick(e) {
		e.preventDefault();
		console.log(e.target);
		setSelected(e.target.id);
	}

	const TAG = [
		"All",
		"Beauty & Health",
		"Books & Stationery",
		"Departmental Stores",
		"Education",
		"Electrical & Electronics",
		"Entertainment",
		"Fashion & Accessories",
		"Food & Beverages",
		"Gifts & Souvenirs",
		"Homeware & Furnishings",
		"IT & Telecommunications",
		"Jewellery & Watches",
		"Kids",
		"Lifestyle",
		"Machines",
		"Medical & Dental",
		"Music & Video",
		"Shoes & Bags",
		"Sporting Goods & Apparel",
		"Sundry & Services",
		"Supermarket/Hypermarket",
		"Toys & Hobbies",
	];

	return (
		<div className="w-screen h-screen flex items-center flex-col">
			<div className="w-full font-bold text-5xl flex items-center justify-center h-1/6">
				Category
			</div>

			<div className="w-full flex justify-start items-star flex-row h-5/6">
				<div id="categories" className="w-1/5 h-full p-3 overflow-y-scroll">
					{TAG.map((item, index) => (
						<button
							key={index}
							className={`w-full h-14 flex items-center text-black text-lg ${
								selected === item ? "font-bold" : ""
							} `}
							id={item}
							onClick={handleClick}
						>
							{item}
						</button>
					))}
				</div>
				<div className="w-4/5 h-full grid items-center justify-center grid-cols-3 overflow-scroll gap-5 px-3 pb-5">
					{stores.map((item, index) => (
						<StoreCard key={index} image={item.imageUrl} name={item.name} />
					))}
				</div>
			</div>
		</div>
	);
}

function StoreCard({ image, name, no }) {
	return (
		<Link
			className="w-full h-56 flex items-center justify-center bg-black relative rounded-xl overflow-clip shadow-xl"
			to={`/store/${name}`}
		>
			<img
				className="w-full h-full absolute z-0 object-cover opacity-60"
				src={image}
				alt=""
			/>
			<div className="w-full h-full absolute z-10 flex items-start justify-end top-0 left-0 flex-col p-5">
				<p className="text-white text-2xl font-bold">{name}</p>
				{no && <p className="text-white text-lg">#{no}</p>}
			</div>
		</Link>
	);
}
